import { useTheme, useMediaQuery, Typography, Breadcrumbs, Box } from "@material-ui/core"
import { Trans } from "@lingui/macro"
import { NavLink } from "react-router-dom"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  breadcrumbs: {
    "& .MuiBreadcrumbs-separator": {
      margin: 0
    }
  },
  regularBreadcrumbs: {
    "& .MuiBreadcrumbs-separator": {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5)
    }
  }
}))

const CategoryBreadcrumbs = ({ ancestors, breadcrumbs, plainText = false, disabledLink = false }) => {
  const theme = useTheme()
  const xs = useMediaQuery(theme.breakpoints.down("xs"))
  const classes = useStyles()

  const renderBreadcrumb = (path, index) => {
    if (plainText || index === breadcrumbs.length - 1 || disabledLink) {
      return <Typography variant={plainText ? "caption" : "body2"}>{path}</Typography>
    }

    return <NavLink to={`/knowledge/category/${ancestors[index]}`}>{path}</NavLink>
  }

  const renderMainBreadcrumb = () => {
    if (plainText) {
      return null
    }

    if (disabledLink) {
      return <Trans>Knowledge Base</Trans>
    }

    return <NavLink to="/knowledge">Knowledge Base</NavLink>
  }

  return (
    <Box mb={plainText ? 0 : xs ? 2 : 4} data-cy="KnowledgeArticle-breadcrumbs">
      <Breadcrumbs className={plainText ? classes.breadcrumbs : classes.regularBreadcrumbs}>
        {renderMainBreadcrumb()}
        {breadcrumbs &&
          breadcrumbs.length > 0 &&
          breadcrumbs.map((path, index) => <Box key={`${path.id}-${index}`}>{renderBreadcrumb(path, index)}</Box>)}
      </Breadcrumbs>
    </Box>
  )
}

export { CategoryBreadcrumbs }
